import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AdminFilms from "./admin/AdminFilms";
import AdminProfessionals from "./admin/AdminProfessionals";
import AdminFestivals from "./admin/AdminFestivals";
import AdminProjects from "./admin/AdminProjects";
import AdminMessages from "./admin/AdminMessages";
import AdminPayments from "./admin/AdminPayments";

const TABS = [
  { id: "films", label: "Films", component: AdminFilms },
  { id: "professionals", label: "Network", component: AdminProfessionals },
  { id: "festivals", label: "Festivals & Events", component: AdminFestivals },
  { id: "projects", label: "Productions", component: AdminProjects },
  { id: "messages", label: "Messages", component: AdminMessages },
  { id: "payments", label: "Payments", component: AdminPayments },
];

export default function Admin() {
  const { user, loading } = useAuth();
  const [tab, setTab] = useState("films");

  if (loading) return <div className="min-h-[60vh] flex items-center justify-center" data-testid="admin-loading">Loading…</div>;
  if (!user) return <Navigate to="/signin?next=/admin" replace />;
  if (!user.is_admin) {
    return (
      <div className="bg-[#FFF8E7] min-h-[60vh] flex items-center justify-center px-4" data-testid="admin-denied">
        <div className="bg-white border-2 border-[#0A0A0A] pop-shadow p-10 max-w-md">
          <div className="text-sm uppercase tracking-[0.2em] font-bold text-[#FF2E63] mb-3">Restricted</div>
          <h1 className="font-heading font-black text-[#0A0A0A] text-3xl tracking-tight">Admins only.</h1>
          <p className="mt-3 text-[#2C2C2C]">Your account ({user.email}) is not in the admin list.</p>
        </div>
      </div>
    );
  }

  const Active = TABS.find((t) => t.id === tab)?.component || AdminFilms;

  return (
    <div className="bg-[#FFF8E7] min-h-screen" data-testid="page-admin">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <div className="inline-block bg-[#1A5DFF] text-[#FFF8E7] px-3 py-1 text-xs uppercase tracking-[0.2em] font-bold mb-3 border-2 border-[#0A0A0A]">Admin</div>
          <h1 className="font-heading font-black text-[#0A0A0A] text-4xl sm:text-5xl tracking-tight leading-tight">Control room.</h1>
          <p className="mt-2 text-[#2C2C2C]">Signed in as {user.email}</p>
        </div>

        <div className="flex flex-wrap gap-0 mb-8 border-b-2 border-[#0A0A0A]" role="tablist" data-testid="admin-tabs">
          {TABS.map((t) => (
            <button
              key={t.id}
              role="tab"
              aria-selected={t.id === tab}
              data-testid={`admin-tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`px-6 py-3 font-heading font-bold text-base uppercase tracking-[0.12em] border-2 border-[#0A0A0A] -mb-0.5 transition-colors ${
                t.id === tab
                  ? "bg-[#FF2E63] text-[#FFF8E7]"
                  : "bg-[#FFF8E7] text-[#0A0A0A] hover:bg-[#FFD93D]"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <Active />
      </section>
    </div>
  );
}
